import React, { useState, useEffect, useRef, useCallback } from 'react';
import { getQSDashboardEmbedLinksSync } from "../../Ateam-BI/Templates/Utils/AppActivityUtils"
import {
    AppLayout,
    Badge,
    Box,
    BreadcrumbGroup,
    Button,
    ColumnLayout,
    Container,
    Tabs,
    Grid,
    Header,
    HelpPanel,
    Icon,
    Modal,
    SpaceBetween,
    Spinner,
    Alert,
    Table,
    ExpandableSection,
    Flashbar,
    StatusIndicator,
    Link,
    Multiselect,
    TextContent
} from "@amzn/awsui-components-react";

import {quicksightAccountMapper} from '../../constants/AppConstants'
import DocumentViewer from 'src/Ateam-BI/Vault/components/DocumentViewer';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { SANITIZE_ALLOWED_TAGS, SANITIZE_ALLOWED_ATTRIBUTES } from './constants';

const currentStage = 'beta';


export const getEmbedableContentBasedOnType = async (jsonContent, contentType, tabType, optionalParams={}) => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const d = new Date();
    let month = months[d.getMonth()];
    let year = d.getFullYear();
    if (contentType === 'QUICKSIGHT') {
        
        let urlSplit =  jsonContent?.url?.replace(/\/$/, '').split("/")
        let foundDashboardsIndex = urlSplit?.findIndex((e)=> e == 'dashboards')
        let foundAccountsIndex = urlSplit?.findIndex((e)=> (e == 'account' || e == 'accounts'))
        let dashboardId = '';
        let region = 'us-east-1';
        let account = 'FGBSBI'
        if(foundDashboardsIndex !== -1 && urlSplit) {
            dashboardId = urlSplit[foundDashboardsIndex + 1] 
        }
        if(foundAccountsIndex !== -1 && urlSplit) {
            let accountId = urlSplit[foundAccountsIndex + 1] 
            for (const [key, accountAliases] of Object.entries(quicksightAccountMapper)) {
            let found = accountAliases.findIndex((e)=> e.toUpperCase() === accountId.toUpperCase())
            if(found !== -1) {
                account = key
                break;
            }
            }
        }
        
        if(urlSplit && urlSplit[2].includes("quicksight")){
        region = urlSplit[2].split(".")[0]
        }
        
        if(account && region && dashboardId) {
            const url = await getQSDashboardEmbedLinksSync(account, region, dashboardId)
        if (tabType === 'BOARD') {
            return (<>
                <iframe
                    className="cp_embedment"
                    src={url?.url}>
                </iframe>
            </>)
        } else {
            return (<>
                <iframe
                    className="cp_embedment_non_home"
                    src={url?.url}>
                </iframe>
            </>)
        }
        } else {
            return (<><span style={{ color: "#db0000" }}>A Valid Quicksight dashboard URL not found!</span></>)
        }

    } else if (contentType === 'PDF') {
        return <DocumentViewer viewType = {tabType === 'BOARD' ? 'expandable' : 'fixed'}contentType="pdf" service={VAULT_SERVICES.CLOSE_PORTAL} serviceParams = {{"file_id": jsonContent?.file_id, "owner_id": optionalParams?.owner_id}}/>
    } 
    else if (contentType === 'WEBPAGE') {
        if (currentStage !== 'dev') {
            if (tabType === 'BOARD') {
                return (<>
                    <iframe
                        className="cp_embedment"
                        src={jsonContent?.url?.startsWith('https://broadcast.amazon.com/videos/') ? generateEmbedableBroadcastLinkFromVideoLink(jsonContent?.url) : jsonContent?.url}>
                    </iframe>
    
                </>)
            } else {
                return (<>
                    <iframe
                        className="cp_embedment_non_home"
                        src={jsonContent?.url?.startsWith('https://broadcast.amazon.com/videos/') ? generateEmbedableBroadcastLinkFromVideoLink(jsonContent?.url) : jsonContent?.url}>
                    </iframe>
                </>)
            }
        } else {
            return (<></>)
        }
       

    } else if (contentType === 'TEXT') {
        const displayText = jsonContent?.text ? getCleanedItemContent(jsonContent.text) : '';
        if (displayText) {
            const sanitized = DOMPurify.sanitize(displayText, {
                ALLOWED_TAGS: SANITIZE_ALLOWED_TAGS,
                ALLOWED_ATTR: SANITIZE_ALLOWED_ATTRIBUTES,
            });
            return (<>
                <Box>
                    <div>{parse(sanitized)}</div>
                </Box>
            </>)
        } else {
            return (<></>)
        }

    } else if (contentType === 'KEY-VALUE-LINKS') {

        if (jsonContent?.links?.length) {
            return (<>
                <Box> <ul style={{ listStyleType: "none", paddingLeft:"5px"}}>
                    {jsonContent?.links?.map((item) => (
                        <li key={item?.label}><Link
                            external
                            href={item?.value}
                            variant="secondary"
                            
                        >
                           <span style={{ fontWeight: "700", fontSize:"20px", lineHeight:"24px"}}> {item?.label} </span>
                        </Link></li>
                    ))}
                </ul></Box>
            </>)
        } else {
            return (<></>)
        }

    } 
    else {
        return (<>Invalid Content Type</>)
    }

}

export const validateURL = (url, validationType, validationString) => {

    if(validationType == 'startsWith') {
        return url?.startsWith(validationString)
    } else if(validationType == 'includes') {
        return url?.includes(validationString)
    }
    return false;
}

export const getWebResourcetype = (url) => {
    if(url?.startsWith('https://w.amazon.com/')) {
        return "WIKI"
    } else if (url?.startsWith('https://broadcast.amazon.com/videos/')) {
        return "BROADCAST"
    } else if (url?.startsWith('https://issues.amazon.com/')) {
        return "SIM"
    } else if (url?.startsWith('https://console.harmony.a2z.com/internal-ai-assistant')) {
        return "CEDRIC-PERSONA"
    } else if(url?.startsWith('https://starmap.fgbs.amazon.dev/')) {
        return "STARMAP"
    } else if(url?.startsWith('https://')) {
        return "WEBPAGE"
    }
    return "INVALID"
}

export const validateURLByWebResource = (url, webResourceType) => {

    if(webResourceType == 'WIKI') {
        return url?.startsWith('https://w.amazon.com/')
    } else if(webResourceType == 'BROADCAST') {
        return url?.startsWith('https://broadcast.amazon.com/videos/')
    } else if (webResourceType == 'SIM') {
        return url?.startsWith('https://issues.amazon.com/')
    } else if (webResourceType == 'CEDRIC-PERSONA') {
        return url?.startsWith('https://console.harmony.a2z.com/internal-ai-assistant')
    } else if (webResourceType == 'STARMAP') {
        return url?.startsWith('https://starmap.fgbs.amazon.dev/')
    } else if (webResourceType == 'MAGNIFY') {
        return url?.startsWith('https://prod.magnify.fintech.amazon.dev')
    } else if (webResourceType == 'ACR') {
        return url?.startsWith('https://bi-central.accounting.amazon.dev') || url?.startsWith('https://beta.bi-central.accounting.amazon.dev')
    } else if (webResourceType == 'AMAZON-BI-QS') {
        return (url?.startsWith("https://") && url?.includes("quicksight") && url?.includes("dashboards") && url?.includes("embed"))
    } else if (webResourceType == 'QUICKSIGHT') {
        return (url?.startsWith("https://") && url?.includes("quicksight") && url?.includes("dashboards"))
    } else if (webResourceType == 'WEBPAGE') {
        return (url?.startsWith("https://"))
    }
    return false;
}

export const generateEmbedableBroadcastLinkFromVideoLink = (url) => {
    let videoId = ""
    let embedableLink = "https://broadcast.amazon.com/embed/"
    let urlSplit =  url?.replace(/\/$/, '').split("/")
    let foundVideosIndex = urlSplit?.findIndex((e)=> e == 'videos')
    if(foundVideosIndex !== -1 && urlSplit) {
        videoId = urlSplit[foundVideosIndex + 1] 
    }

    if(videoId && videoId !== "") {
        return `${embedableLink}${videoId}`
    }
    return embedableLink
}

export const cleanItemContent = (content='') => {
    return content.replaceAll("\\","%92%")?.replaceAll("/","%47%")?.replaceAll("'","%39%")?.replaceAll("\n"," ")?.replaceAll('"','%34%')
}

export const getCleanedItemContent = (content='') => {
    return content.replaceAll("%39%", "'")?.replaceAll('%34%', '"')?.replaceAll('%92%', '\\')?.replaceAll('%47%', '/')
}

export const safeParseStoredJSON = (str) => {
    if (!str) return null;
    try {
        // Safely parse URL strings
        return JSON.parse(str.replaceAll("\\", "\\\\").replaceAll("'", '"'));
    } catch {
        // Fallback: try the raw swap in case the data was already properly escaped
        try {
            return JSON.parse(str.replaceAll("'", '"'));
        } catch {
            return null;
        }
    }
}